module.exports = __webpack_public_path__ + "images/emoji/black_circle.82c9015d083ec1813f39.png";